export default __webpack_public_path__ + "static/media/parcel-logo.86b4469b.svg";